import React, { useState, useEffect } from "react";
import Spinner from "@salesforce/design-system-react/module/components/spinner";

const Loading = ({ isLoading }) => {
  const spinner = () => {
    if (isLoading) {
      return (
        <Spinner
          size="small"
          variant="base"
          assistiveText={{ label: "Loading..." }}
        />
      );
    } else {
      return null;
    }
  };

  return spinner();
};

export default Loading;
